import { CheckCircle, Clear, Done, Edit, Grading, Info, Report, Search } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Grid, Tooltip, Typography } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortModel, GridSortDirection } from "@mui/x-data-grid";
import { addMonths, format, parse } from "date-fns";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DatePicker from "../../../components/hookForms/datePicker";
import DialogConfirm from "../../../components/confirmationDialog";
import DialogEdit from "./modal/dialogEdit";
import DialogError from "./modal/dialogError";
import DatePickerMui from "../../../components/hookForms/datePicker";
import TextInput from "../../../components/hookForms/textField";
import { downloadFileFromBase64 } from "../../../utils/utils";
import messages from "../../../utils/messages";
import serviceFaturaCliente from "../../../services/serviceFaturaCliente";
import { toast } from "react-toastify";
/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

const ClienteInstalacao = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Faturamento - Faturas de Clientes");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [buttonSelected, setButtonSelected] = useState<any[]>(["Aberta"]);
    const [filters, setFilters] = useState(null);
    const [isPublish, setIsPublish] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [qtdeFatura, setQtdeFatura] = useState(0);
    const [disableButton, setDisableButton] = useState(0);
    const [disablePublishAllButton, setDisablePublishAllButton] = useState(false);
    const [isConfirm, setIsConfirm] = useState(false);
    const [disableConfirmButton, setDisableConfirmButton] = useState(false);

    const { handleGetDataUser } = useAuth();
    const user = handleGetDataUser();
    const isAdmin = user.perfil === "Admin";

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection
        }
    ]);

    const publishMessage = {
        multiple: `Tem certeza que deseja publicar todas as ${qtdeFatura} faturas pendentes?`,
        simple: "Tem certeza que deseja publicar esta fatura pendente?",
    };

    const faturaSelecionada = data.map((item) => item.faturaClienteID);

    const [editState, setEditState] = useState({
        open: false,
        id: "",
        dataVencimentoFatura: new Date(),
        nomeCliente: "",
        flagCancelada: "",
        statusFatura: "",
    });

    const [errorState, setErrorState] = useState({ open: false, id: "", error: "", faturaID: "" });
    const history = useHistory();

    const pago = [
        { label: "Sim", value: "Sim" },
        { label: "Não", value: "Não" },
        { label: "Ambos", value: "Ambos" },
    ];
    const cancelado = [
        { label: "Sim", value: "Sim" },
        { label: "Não", value: "Não" },
        { label: "Ambos", value: "Ambos" },
    ];

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            cicloFaturamento: null,
            dataVencimento: null,
            flagCancelada: "",
            flagHabilitado: "",
            flagPaga: "",
            nomeCliente: "",
            codigoExternoCliente: "",
            statusFaturaCliente: "Aberta",
        },
    });

    const statusOptions = [
        { label: "Aberta", value: "Aberta" },
        { label: "Aguardando Publicação", value: "Aguardando Publicação" },
        { label: "Publicada", value: "Publicada" },
        { label: "Erro", value: "Erro" },
        { label: "Confirmando Publicação", value: "Confirmando Publicação" },
    ];

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 250,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Fatura de instalação">
                                <Info />
                            </Tooltip>
                        }
                        label="Fatura de instalação"
                        onClick={() => {
                            onClickInfo(params.row.faturaClienteID);
                        }}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Relatório de consumo">
                                <Grading />
                            </Tooltip>
                        }
                        label="Baixar"
                        onClick={() => onClickDownload(params.row)}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Publicar">
                                <Done />
                            </Tooltip>
                        }
                        label="Publicar"
                        onClick={() => {
                            handlePublish(params.id);
                        }}
                        disabled={
                            params.row.statusFaturaCliente === "Confirmando Publicação" ||
                            params.row.statusFaturaCliente === "Aguardando Publicação" ||
                            params.row.statusFaturaCliente === "Publicada" ||
                            params.id === disableButton
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                dataVencimentoFatura: parse(params.row.dataVencimentoFatura, "dd/MM/yyyy", new Date()),
                                nomeCliente: params.row.nomeCliente,
                                flagCancelada: params.row.flagCancelada,
                                statusFatura: params.row.statusFaturaCliente,

                            })
                        }
                        disabled={
                            (params.row.statusFaturaCliente === "Publicada" && !isAdmin) ||
                            params.row.statusFaturaCliente === "Aguardando Publicação" ||
                            params.row.statusFaturaCliente === "Confirmando Publicação"
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Erros">
                                <Report />
                            </Tooltip>
                        }
                        label="Erros"
                        onClick={async () => {
                            setErrorState({
                                open: true,
                                id: params.id.toString(),
                                faturaID: params.row.faturaClienteID,
                                error: "",
                            });
                        }}
                        disabled={params.row.statusFaturaCliente !== "Erro"}
                    />,

                ],
            },
        ],
        [disableButton, filters]
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                type: "number",
                headerAlign: "left",
                field: "faturaClienteID",
                identity: true,
                // id: 70,
            },
            {
                headerName: "Ciclo",
                field: "cicloFaturamento",
                type: "string",
                width: 100,
            },
            {
                headerName: "Cliente",
                field: "nomeCliente",
                type: "string",
                width: 250,
            },
            {
                headerName: "Código externo",
                field: "codigoExternoCliente",
                type: "string",
                width: 120,
            },
            {
                headerName: "Valor total (R$)",
                field: "valorTotalFatura",
                type: "number",
                headerAlign: "left",
                width: 150,
            },
            {
                headerName: "Total injetado (kWh)",
                field: "totalInjetado",
                type: "number",
                headerAlign: "left",
                width: 160,
            },
            {
                headerName: "Vencimento",
                field: "dataVencimentoFatura",
                type: "string",
                width: 110,
            },
            {
                headerName: "Paga",
                field: "flagPaga",
                type: "string",
                width: 80,
            },
            {
                headerName: "Cancelada",
                field: "flagCancelada",
                type: "string",
                width: 120,
            },
            {
                headerName: "Status",
                field: "statusFaturaCliente",
                type: "string",
                width: 100,
            },
            {
                headerName: "Data Publicação",
                field: "dataPublicacao",
                type: "string",
                width: 130,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        if (!filters) {
            filters = { statusFaturaCliente: "Aberta" };
        }

        const newFilters = {
            ...filters,
            dataVencimento: filters.dataVencimento ?
                (filters.dataVencimento.length === 10 ?
                    filters.dataVencimento
                    : format(filters?.dataVencimento, "dd/MM/yyyy"))
                : ""
        };

        serviceFaturaCliente
            .getWithFilter({
                ...newFilters, take: pageSize, currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "", sortDirection: sortModel[0]?.sort ?? ""
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            flagHabilitado: values.flagHabilitado === "Todos" ? "" : values.flagHabilitado,
            statusFaturaCliente: buttonSelected.join(","),
            dataVencimento: values.dataVencimento ? format(values?.dataVencimento, "dd/MM/yyyy") : "",
            flagPaga: values.flagPaga === "Ambos" ? "" : values.flagPaga,
            flagCancelada: values.flagCancelada === "Ambos" ? "" : values.flagCancelada,
            cicloFaturamento: values.cicloFaturamento ? format(values.cicloFaturamento, "MM/yyyy") : "",
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    const onClickDownload = async (data: any) => {
        setLoading(true);

        const ciclo = "01/" + data.cicloFaturamento;
        const [day, month, year] = ciclo.split("/");

        const finalDate = new Date(+year, +month - 1);
        const initialDate = addMonths(new Date(+year, +month, +day), -13);

        const values = {
            clienteID: data.clienteID,
            dataInicio: initialDate ? format(initialDate, "dd/MM/yyyy") : "",
            dataFim: finalDate ? format(finalDate, "dd/MM/yyyy") : "",
        };

        await serviceFaturaCliente
            .getRelatorioConsumo(values)
            .then((result) => {
                downloadFileFromBase64(result.data.base64, `Relatorio_de_consumo${data.faturaClienteID}`, "pdf");
            })
            .catch((err) => {
                toast.error(messages.downloadError, err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onClickInfo = (faturaClienteID: any) => {

        history.push(
            "/faturamento/faturainstalacao",
            {
                faturaClienteID: faturaClienteID,
                statusFaturaInstalacao: "",
                filterOld: filters,
                rotaAnterior: "/faturamento/faturacliente"
            },
        );
    };

    const onClear = () => {
        setButtonSelected(["Aberta"]);

        reset({
            cicloFaturamento: null,
            dataVencimento: null,
            flagCancelada: "",
            flagHabilitado: "",
            flagPaga: "",
            nomeCliente: "",
            codigoExternoCliente: "",
            statusFaturaCliente: "Aberta",
        });

        setFilters(null);
        getAllWithFilters(null);
    };

    const handlePublish = async (id?: any) => {
        setDisableButton(id);
        setDisablePublishAllButton(true);
        setLoading(true);

        let dataId = {};
        if (id) {
            dataId = { ids: id.toString() };
        } else {
            const allId = data.map((item) => item.faturaClienteID);
            dataId = { ids: allId.join() };
        }

        serviceFaturaCliente
            .publish(dataId)
            .then((result) => {
                if (result && result.status === 200) {
                    toast.info("A publicação da fatura será realizada, por favor aguarde.");
                }
            })
            .catch((err) => {
                toast.error("Ocorreu um erro ao realizar a publicação de fatura!", err);
            })
            .finally(() => {
                setDisableButton(0);
                setDisablePublishAllButton(false);
                setLoading(false);
                getAllWithFilters(filters);
            });
    };

    const handleConfirm = async () => {
        setDisableConfirmButton(true);
        setLoading(true);

        const values = {
            dataPublicacao: format(new Date(), "yyyy-MM-dd")
        };

        serviceFaturaCliente
            .confirm(values)
            .then((result) => {
                if (result && result.status === 200) {
                    toast.info("A confirmação das faturas será realizada, por favor aguarde.");
                }
            })
            .catch((err) => {
                toast.error("Ocorreu um erro ao realizar a confirmação das faturas!", err);
            })
            .finally(() => {
                setDisableConfirmButton(false);
                setLoading(false);
                getAllWithFilters(filters);
            });
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    useEffect(() => {
        if (props && props.location && props.location.state) {
            if (props.location.state.statusFaturaCliente) {
                const newArray = props.location.state.statusFaturaCliente
                    ? Array.isArray(props.location.state.statusFaturaCliente)
                        ? props.location.state.statusFaturaCliente
                        : props.location.state.statusFaturaCliente.split(",")
                    : "";

                setButtonSelected(newArray);
            }
            else {
                setButtonSelected([]);
            }

            reset({ ...props.location.state });
            setFilters(props.location.state);

            const newFilters = {
                ...props.location.state,
                cicloFaturamento: props.location.state.cicloFaturamento ?
                    format(props.location.state.cicloFaturamento, "MM/yyyy") : "",
            };

            getAllWithFilters(newFilters);
        }
    }, [props]);

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={2}>
                                            <DatePickerMui
                                                name="cicloFaturamento"
                                                label="Ciclo"
                                                format="MM/yyyy"
                                                view={["month", "year"]}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <TextInput
                                                name="codigoExternoCliente"
                                                label="Código externo"
                                                control={control}
                                                error={errors}
                                                maxLength={20}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <TextInput
                                                name="nomeCliente"
                                                label="Cliente"
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                style={{ marginTop: 16, marginBottom: 8 }}
                                                variant="contained"
                                                color="primary"
                                                startIcon={<CheckCircle />}
                                                onClick={() => {
                                                    setIsPublish(true);
                                                    setQtdeFatura(faturaSelecionada.length);
                                                }}
                                                disableElevation
                                                fullWidth
                                                size="medium"
                                                disabled={disablePublishAllButton}
                                            >
                                                Publicar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={2}>
                                            <DatePicker
                                                name="dataVencimento"
                                                label="Vencimento"
                                                control={control}
                                                error={errors}
                                                noDateForward={false}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <AutoComplete
                                                name="flagPaga"
                                                label="Paga"
                                                options={pago}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <AutoComplete
                                                name="flagCancelada"
                                                label="Cancelada"
                                                options={cancelado}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="outlined"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>

                                        <Grid item xs={12} md={2} display="flex" alignItems="center">
                                            <Button
                                                style={{ marginTop: 16, marginBottom: 8 }}
                                                variant="contained"
                                                color="primary"
                                                startIcon={<Done />}
                                                onClick={() => {
                                                    setIsConfirm(true);
                                                    setQtdeFatura(faturaSelecionada.length);
                                                }}
                                                disableElevation
                                                fullWidth
                                                size="medium"
                                                disabled={!isAdmin || disableConfirmButton}
                                            >
                                                Confirmar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item sx={{ mt: 2 }}>
                                    <Typography variant="subtitle2" color="#5B5B5F">
                                        Status:
                                        {statusOptions.map((item, index) => {
                                            return (
                                                <Button
                                                    key={index}
                                                    variant={
                                                        buttonSelected.includes(item.value) ? "contained" : "outlined"
                                                    }
                                                    color="warning"
                                                    size="small"
                                                    disableElevation
                                                    onClick={() => {
                                                        setButtonSelected((oldstate) => {
                                                            if (oldstate.includes(item.value)) {
                                                                return oldstate.filter((e) => e !== item.value);
                                                            } else {
                                                                return [...oldstate, item.value];
                                                            }
                                                        });
                                                    }}
                                                    style={{ margin: "0px 12px", minWidth: "150px", height: "33px" }}
                                                >
                                                    {item.label}
                                                </Button>
                                            );
                                        })}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.faturaClienteID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            dataVencimentoFatura: editState.dataVencimentoFatura,
                            nomeCliente: editState.nomeCliente,
                            flagCancelada: editState.flagCancelada,
                            statusFatura: editState.statusFatura,

                        }}
                        onClose={() => {
                            setEditState({ open: false, id: "", dataVencimentoFatura: new Date(), nomeCliente: "", flagCancelada: "", statusFatura: "", });
                        }}
                    />

                    <DialogError
                        open={errorState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: errorState.open,
                            id: errorState.id,
                            error: errorState.error,
                            faturaID: errorState.faturaID,
                        }}
                        onClose={() => {
                            setErrorState({ open: false, id: "", error: "", faturaID: "" });
                        }}
                    />

                    <DialogConfirm
                        open={isPublish}
                        title={"Publicar faturas pendentes?"}
                        message={qtdeFatura > 1 ? publishMessage.multiple : publishMessage.simple}
                        cancelButtonText={"Cancelar"}
                        confirmButtonText={"Confirmar"}
                        onClose={() => setIsPublish(false)}
                        onCancel={() => setIsPublish(false)}
                        onConfirm={() => {
                            setIsPublish(false);
                            handlePublish();
                        }}
                    />

                    <DialogConfirm
                        open={isConfirm}
                        title={"Confirmar faturas publicadas"}
                        message={"Tem certeza que deseja confirmar as faturas publicadas hoje?"}
                        cancelButtonText={"Cancelar"}
                        confirmButtonText={"Confirmar"}
                        onClose={() => setIsConfirm(false)}
                        onCancel={() => setIsConfirm(false)}
                        onConfirm={() => {
                            setIsConfirm(false);
                            handleConfirm();
                        }}
                    />

                </CardContent>
            </Card>
        </Container>
    );
};

export default ClienteInstalacao;
